module.exports = __webpack_public_path__ + "static/media/summary-gray.8b3c1496.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/summary-gray.svg
// module id = 1656
// module chunks = 0